import React from 'react';
import NavbarDefault from "../components/navbarDefault";
import FooterDefault from "../components/footerDefault";
import { Grid, Typography } from '@mui/material';

import { createTheme, responsiveFontSizes } from '@mui/material';
import { ThemeProvider } from '@emotion/react';

let theme = createTheme({
  typography: {
    fontFamily: [
      'Segoe UI', 
      'sans-serif',
    ].join(','),
  }
});

theme = responsiveFontSizes(theme);

function LOA() {
    return(
        <ThemeProvider theme={theme}>
        <NavbarDefault />
            <Grid         
                container
                direction="row"
                justifyContent="center"
                height="50%"
                sx={{ flexGrow: 1, 
                paddingBottom: 2,
                paddingRight: 2,
                marginTop: 2,
                marginLeft: "auto",
                marginRight: "auto",
                marginBottom: 5,
                maxWidth: 1,
                alignItems: "center"
                }}
                spacing={2}
            >
                <Grid item xs={8} sx={{textAlign: 'justify'}}>
                    <Typography variant='h4' fontFamily="Segoe UI" fontWeight={700} marginBottom={4}>
                        FILING OF LEAVE OF ABSENCE (LOA)
                    </Typography>
                    <Typography variant='b1' fontFamily="Segoe UI">
                        A student who does not intend to enroll in a semester may apply for a leave of absence (LOA). This also applies to a student currently enrolled and who intends
                        to withdraw his/her enrollment for the rest of the semester. A student on leave of absence does not sever his/her ties with the University.<br/><br/>

                        A request for a leave of absence should be made in writing to the Dean. The request should state the reason for the leave and should specify the period. The
                        leave may be approved for a period of one (1) year but may be renewed for at most another year (Revised UP Code: Art. 401).<br/><br/>

                        If a student withdraws after three-fourths (¾) of the total number of hours prescribed for the subject has already elapsed, the faculty member may submit a grade
                        of 5.00 for the subject if the class standing up to the time of the withdrawal is below 3.00 (Revised UP Code: Art. 402).<br/><br/>

                        A student who withdraws from a college without formal leave of absence [considered “absent without leave” status or AWOL] shall have his/her registration
                        privileges curtailed or entirely withdrawn (Revised UP Code: Art. 403).<br/><br/>

                        The following are the guidelines on filing for a leave of absence (822nd BOR Meeting: 31 July 1972):<br/><br/>

                        1) the College, through the Dean or the duly authorized representative, shall inform the University Registrar and the parents/guardian of every student granted
                        leave of absence, indicating the reasons for the leave and the amount of money refunded to the student, if any;<br/><br/>

                        2) for a leave of absence to be availed of by the student himself/herself, during the second half of the semester, faculty members concerned shall be required to
                        indicate the class standing of the student (“Passing” or “Failing”) at the time of the application for the leave. No application for leave of absence shall be approved
                        without the class standing being indicated by the instructors concerned. This class standing, however, should not be entered in the official Report of Grades;<br/><br/>

                        3) no leave of absence shall be granted during the semester within two (2) weeks before the last day of classes.
                        If the inability of the student to continue classes is for reasons of health or similar justifiable causes, the absence during this period shall be considered excused.
                        In such cases, the students shall be required to apply for excuse from the absences. It shall be the responsibility of the student to present an excuse slip to the faculty
                        members concerned.<br/><br/>
                        A student returning from a leave of absence shall declare his/her intention to enroll by writing to the University Registrar through his/her College Secretary. The
                        latter shall write the remarks “From LOA” on the student’s Form 5.    
                    </Typography>
                </Grid>
            </Grid>
        <FooterDefault /> 
        </ThemeProvider>
    )
}

export default LOA